import React, { Fragment, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import axios from 'axios';
import { Spinner } from 'components/ira/ui/Spinner';
import { LOCAL_STORAGE_KEY } from 'constants/localStorage';
import * as EmailValidator from 'email-validator';
import { ErrorMessage, Formik } from 'formik';
import useEnterKey from 'hooks/useKeydown';
import { requestStates, useRequestState } from 'hooks/useRequestState';
import ls from 'local-storage';
import { useDispatch } from 'redux-react-hook';
import { GUEST_ROUTES } from 'routes/routes';
import { useResendVerificationKeyMutation } from 'services/api/serviceApi';
import { logIn, signUp } from 'store/DEPRECATEDusers/asyncAction';
import styled from 'styled-components';
import { isBlank } from 'utils/storeUtils';
import * as Yup from 'yup';

import { API_ENDPOINT } from '../../../api/constants';
import UsersAPI from '../../../api/UsersAPI';
import eye_icon from '../../../assets/eye.svg';
import eye_off_icon from '../../../assets/eye-off.svg';
import google_icon from '../../../assets/Google.svg';
import lock_icon from '../../../assets/lock.svg';
import mail_icon from '../../../assets/mail.svg';
import MailReactIcon from '../../../assets/mail.svg?react';
import {
  isLoginMode,
  isRecoverMode,
  isResendMode,
  isSignupMode,
  LOGIN_MODE,
  RECOVER_MODE,
  RESEND_MODE,
  SIGNUP_MODE
} from '../../../constants/auth.ts';

const initialFormValues = { email: '', password: '', passwordConfirmation: '' };

export default function AuthForm(props) {
  const { mode: defaultMode, onClose } = props;

  const { requestState: { isLoading }, setLoading, setFailed, setSuccess } = useRequestState(requestStates.initial);
  const [resendVerificationKey, { isLoading: isLoadingResendEmail }] = useResendVerificationKeyMutation();
  const dispatch = useDispatch();

  const [recovering, setRecovering] = useState(false);
  const [recoverySent, setRecoverySent] = useState(false);
  const [mode, setMode] = useState(defaultMode || LOGIN_MODE);


  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email('Please enter a valid email address')
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        'Please enter a valid email address'
      )
      .required('Email is required'),
    password: Yup.string().required('Password is required'),
    passwordConfirmation: Yup.string().when([], {
      is: () => isSignupMode(mode),
      then: (schema) =>
        schema
          .oneOf([Yup.ref('password'), null], 'Passwords must match')
          .required('Password confirmation is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
  });

  const handleResendEmail = async () => {
    if (isLoading) {
      return;
    }
    try {
      await resendVerificationKey().unwrap();
      toast.success('Verification email has been sent. Please check your inbox');
    } catch (exc) {
      toast.error('Email has already been sent. Please check your inbox');
    }
  };

  const handleOnAuthClick = async (values) => {
    const { email, password } = values;

    if (isLoading || recovering) {
      return null;
    }

    const data = {
      email: email,
      password: password
    };

    setLoading();
    if (isSignupMode(mode)) {
      try {
        const result = await dispatch(signUp(data, props));

        if (result?.user && !result?.registrationCompletedWithLogin) {
          try {
            const visitor_id = ls.get('visitor_id');
            if (visitor_id) {
              await fetch(
                `https://sconvtrk.com/conversion/f6bfb4a3ef2b36dc17473a85e583fd36ec2a9dff/?visitor_id=${visitor_id}&aid=288863`
              );
            }

            const click_id = ls.get('click_id');
            if (click_id) {
              await fetch(`https://1tjqs.bemobtrcks.com/postback?cid=${click_id}&goal=1&status=registration`);
            }
            setMode(RESEND_MODE);
          } catch (error) {
            setFailed();
            throw error;
          }
        }
      } catch (error) {
        setFailed();
        throw error;
      }
      setSuccess();
      return;
    }
    try {
      setLoading();
      const payload = await dispatch(logIn(data));
      if (payload?.action?.user === undefined && payload?.user === undefined) {
        toast.error('Incorrect Login or Password');
      }
      setSuccess();
    } catch (error) {
      setFailed();
      throw error;
    }
  };

  const handleCloseResendModal = () => {
    onClose();
  };

  useEffect(() => {
    if (isResendMode(mode)) {
      ls.set(LOCAL_STORAGE_KEY.IS_MAIL_VERIFICATION_ALREADY_SHOWN, true);
    }
  }, []);

  return (
    <Wrapper className={'text-white'}>

      <Formik
        initialValues={initialFormValues}
        onSubmit={handleOnAuthClick}
        validationSchema={validationSchema}
        validateOnChange={false}
      >
        {({ handleSubmit, setFieldValue, setFieldError, values, errors }) => {

          const handleFieldChange = (field, value) => {
            setFieldValue(field, value);
            setFieldError(field, '');
          };

          useEnterKey('Enter', handleSubmit);

          return (
            <>

              {isResendMode(mode) && (
                <ResendMailWrapper>
                  <MailIconWrapper>
                    <MailReactIcon />
                  </MailIconWrapper>
                  <ResendMailDescription>We&apos;ve send you a verification link!<br />Please, check your Inbox and Spam folders</ResendMailDescription>
                  <OkButton onClick={handleCloseResendModal}>Ok</OkButton>
                  <LinkButton disabled={isLoadingResendEmail} onClick={handleResendEmail}>Resend an email</LinkButton>
                </ResendMailWrapper>
              )}

              {!isResendMode(mode) && (
                <>
                  <div className="flex flex-col">
                    <div className="">
                      {isRecoverMode(mode) ? (
                        <h2 className="text-lg text-white" style={{ fontSize: '20px', lineHeight: '22px' }}>
                          Recover password
                        </h2>
                      ) : (
                        <>
                          <h2 className="text-lg text-white">
                            {isLoginMode(mode) ? (
                              <div className={'p-1 text-center'}>
                                <div className={'font-bold'} style={{ fontSize: '20px', lineHeight: '16px' }}>
                                  Sign In
                                </div>
                              </div>
                            ) : (
                              <div className={'p-1 text-center'}>
                                <div className={'font-bold'} style={{ fontSize: '20px', lineHeight: '16px' }}>
                                  Create Account
                                </div>
                              </div>
                            )}
                          </h2>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="mt-4 grid grid-cols-1 gap-y-2">
                    <FormField>
                      <TextField
                        className="focus-within:ring-0 focus:ring-0"
                        icon={mail_icon}
                        label="Email"
                        id="email"
                        name="email"
                        type="email"
                        autoComplete="email"
                        required
                        value={values.email}
                        placeholder={'Your email'}
                        onChange={e => handleFieldChange('email', e.target.value)}
                      />
                      {errors.email && <ErrorMessage name="email" component={StyledErrorMessage} />}
                      {isSignupMode(mode) && isBlank(errors.email) && (
                        <EmailDescription>
                          We&apos;ll send verification link to this email
                        </EmailDescription>
                      )}
                    </FormField>
                    {!isRecoverMode(mode) && (
                      <div className="flex flex-col items-start">
                        <FormField className="flex w-full">
                          <div className="flex w-full">
                            <TextField
                              className="w-full focus-within:ring-0 focus:ring-0"
                              icon={lock_icon}
                              label="Password"
                              id="password"
                              placeholder={'Your password'}
                              name="password"
                              type={passwordVisible ? 'text' : 'password'}
                              autoComplete="current-password"
                              required
                              value={values.password}
                              onChange={e => handleFieldChange('password', e.target.value)}
                            />
                            <button
                              className="flex cursor-pointer items-center justify-around"
                              onClick={() => {
                                setPasswordVisible(!passwordVisible);
                              }}
                            >
                              <Icon
                                src={passwordVisible ? eye_off_icon : eye_icon}
                                alt={'password visibility'}
                                className="absolute mr-12"
                              />
                            </button>
                          </div>
                          {errors.password && <ErrorMessage name="password" component={StyledErrorMessage} />}
                        </FormField>
                        {isLoginMode(mode) && (
                          <div className={'p-0 text-center'}>
                            <p
                              className="mt-2 cursor-pointer text-sm text-white underline"
                              style={{ fontSize: '14px' }}
                              onClick={() => {
                                setMode(RECOVER_MODE);
                              }}
                            >
                              Forgot password?
                            </p>
                          </div>
                        )}
                      </div>
                    )}

                    {isSignupMode(mode) && (
                      <FormField className="flex w-full">
                        <div className="flex w-full">
                          <TextField
                            icon={lock_icon}
                            className="w-full focus-within:ring-0 focus:ring-0"
                            label="Password one more time"
                            id="password"
                            name="password"
                            type={confirmPasswordVisible ? 'text' : 'password'}
                            placeholder={'Confirm password'}
                            autoComplete="current-password"
                            required
                            value={values.passwordConfirmation}
                            onChange={e => handleFieldChange('passwordConfirmation', e.target.value)}
                          />
                          <button
                            className="flex cursor-pointer items-center justify-around"
                            onClick={() => {
                              setConfirmPasswordVisible(!confirmPasswordVisible);
                            }}
                          >
                            <Icon
                              src={confirmPasswordVisible ? eye_off_icon : eye_icon}
                              className="absolute mr-12"
                            />
                          </button>
                        </div>
                        {errors.passwordConfirmation && <ErrorMessage name="passwordConfirmation" component={StyledErrorMessage} />}
                      </FormField>
                    )}


                    {isRecoverMode(mode) ? (
                      <div>
                        {recoverySent ? (
                          <span className={'p-2 text-white'}>Please check your inbox</span>
                        ) : (
                          <Button
                            type="submit"
                            variant="solid"
                            color="blue"
                            className="mt-4 w-full"
                            onClick={async () => {
                              if (!EmailValidator.validate(values.email)) {
                                toast.error('Invalid email');
                                return;
                              }
                              if (isLoading || recovering) {
                                return;
                              }
                              setRecovering(true);
                              await axios.post(`${API_ENDPOINT}/users/recover`, {
                                email: values.email
                              });
                              toast.success('Recovery email sent');
                              setRecovering(false);
                              setRecoverySent(true);
                            }}
                          >
                            <span>
                              {isLoading || recovering ? <Spinner /> : <>Recover password</>}
                            </span>
                          </Button>
                        )}
                      </div>
                    ) : (
                      <div>
                        <Button
                          type="submit"
                          variant="solid"
                          color="blue"
                          className="mt-4 w-full"
                          disabled={isLoading}
                          onClick={handleSubmit}
                        >
                          <span>
                            {isLoading ? (
                              <Spinner />
                            ) : (
                              <>
                                {isLoginMode(mode) ? (
                                  <span>Sign in</span>
                                ) : (
                                  <>
                                    {isRecoverMode(mode) ? (
                                      <span>Recover password</span>
                                    ) : (
                                      <span>Create account</span>
                                    )}
                                  </>
                                )}
                              </>
                            )}
                          </span>
                        </Button>
                      </div>
                    )}
                  </div>

                  {!isRecoverMode(mode) && (
                    <div>
                      <div className="my-6 flex items-center justify-center">
                        <Line />
                        <div className={'white min-w-fit px-2 text-center text-sm leading-4'}>
                          or {isSignupMode(mode) ? 'continue' : 'sign in'} with
                        </div>
                        <Line className="rotate-180" />
                      </div>
                      <div>
                        <div
                          className={
                            'flex w-full cursor-pointer flex-row items-center justify-center p-2 text-white'
                          }
                          style={{ background: '#100D0B', borderRadius: 1000 }}
                          onClick={async () => {
                            await UsersAPI.signInWithGoogle();
                          }}
                        >
                          <Icon src={google_icon} className={'mr-2'} />
                          Google
                        </div>
                      </div>
                    </div>
                  )}

                  {isSignupMode(mode) && (
                    <p className="mt-6 w-full text-center text-xs leading-4 text-[rgb(169,169,169)]">
                      By clicking the button, I confirm that I am at least 18
                      <br /> years old and have read and agree to the <br />
                      <a
                        target="_blank"
                        href={GUEST_ROUTES.TERMS_OF_SERVICE()}
                        className="cursor-pointer text-white underline" rel="noreferrer"
                      >
                        Terms of Service
                      </a>
                      {' and '}
                      <a target="_blank" href={GUEST_ROUTES.PRIVACY_POLICY()} className="cursor-pointer text-white underline" rel="noreferrer">
                        Privacy Policy
                      </a>
                    </p>
                  )}

                  <div className={'p-0 text-center'} style={{ paddingBottom: isRecoverMode(mode) ? 0 : 64 }}>
                    {!isSignupMode(mode) ? (
                      <>
                        {!isRecoverMode(mode) && (
                          <BottomText className="mt-6 border-t border-t-[rgb(104,104,104)] pt-6 font-['Nunito_Sans'] text-sm leading-4 text-gray-100">
                            Don't have an account yet?{' '}
                            <span
                              style={{ color: '#ff7e55' }}
                              className="cursor-pointer font-medium hover:underline"
                              onClick={() => {
                                setMode(SIGNUP_MODE);
                              }}
                            >
                              Sign up
                            </span>
                          </BottomText>
                        )}
                      </>
                    ) : (
                      <BottomText className="mt-6 border-t border-t-[rgb(104,104,104)] pt-6 font-['Nunito_Sans'] text-sm leading-4 text-gray-300">
                        Already have an account?{' '}
                        <span
                          className="cursor-pointer font-medium hover:underline"
                          style={{ color: '#ff7e55' }}
                          onClick={() => {
                            setMode(LOGIN_MODE);
                          }}
                        >
                          Sign in
                        </span>
                      </BottomText>
                    )}
                  </div>
                </>
              )}
            </>
          );
        }}
      </Formik>
    </Wrapper >
  );
}

const Wrapper = styled.div`
  font-family: Nunito Sans;
  font-optical-sizing: auto;
`;

const TextField = styled.input`
  background-color: rgba(19, 19, 19, 1) !important;
  border: none;
  border-radius: 12px;
  padding: 14px;
  color: white;
  outline: none;
  font-size: 16px;

  background: url(${props => props?.icon}) no-repeat;
  background-size: 18px;
  background-position-x: 16px;
  background-position-y: center;
  padding-left: 46px;

  :focus {
    outline: 1px solid rgb(255, 126, 85);
    outline-offset: 0px;
  }

  ::placeholder {
    color: rgba(105, 105, 105, 1);
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus {
    -webkit-text-fill-color: white;
    -webkit-box-shadow: 0 0 0px 1000px rgba(19, 19, 19, 1) inset;
    transition: background-color 5000s ease-in-out 0s;
    background-color: rgba(19, 19, 19, 1) !important;
  }
`;

const Icon = styled.img`
  width: 18px;
  height: 18px;
`;

const Button = styled.div`
  background-color: rgb(255, 126, 85);
  border-radius: 50px;
  color: white;
  font-weight: bold;
  padding-left: 15px;
  padding-right: 15px;
  height: 44px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  cursor: pointer;
  box-shadow: 0px 12px 40px 0px rgba(255, 126, 85, 0.12);

  :hover {
    opacity: 0.8;
  }
`;

const StyledErrorMessage = styled.div`
  color: red;
  font-size: 12px;
  margin-top: 4px;
  padding-left: 6px;
`;


const EmailDescription = styled.div`
  font-size: 12px;
  margin-top: 0.5rem;
  padding-left: 6px;
`;

const Line = styled.div`
  border-width: 1px;
  border-style: solid;
  border-image: linear-gradient(to right, rgba(29, 29, 29, 0) 0%, #a9a9a9 100%) 1;
  width: 80px;
`;

const BottomText = styled.div`
  width: 380px;
  height: 64px;
  position: absolute;
  bottom: 0;
  left: 0;

  @media (max-width: 400px) {
    width: 100%;
    height: fit;
  }
`;


const FormField = styled.div`
  display: flex;
  flex-direction: column;
`;

const ResendMailWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 18px;
`;

const MailIconWrapper = styled.div`
  display: flex;
  justify-content: center
  margin-bottom: 10px;

  svg {
    width: 60px;
    height: 60px;
  }
`;

const ResendMailDescription = styled.p`
  font-family: Nunito Sans;
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  text-align: center;
`;

const OkButton = styled(Button)`
  width: 100%;
`;

const LinkButton = styled.button`
  font-family: Nunito Sans;
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  text-align: center;
  text-decoration: underline;

  :disabled {
  cursor: not-allowed;
  opacity: 0.5;
  }

  `;